/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Content, Profile } from './styles';
import history from '~/services/history';

import logo from '~/assets/logo_deitada.png';

import Menu from '~/components/buttonHeader';

export default function Header() {
  const profile = useSelector(state => state.user.profile.nome);

  function RedirectToHome() {
    history.push({
      pathname: '/MeusImoveis',
    });
  }

  return (
    <Container>
      <Content>
        <img
          src={logo}
          alt="Logo Apolar Imóveis"
          onClick={() => RedirectToHome()}
        />

        <Profile>
          <strong>{profile}</strong>
          <Menu />
        </Profile>
      </Content>
    </Container>
  );
}
